import tools from "./apps/tools";
import { todolist } from "./apps/todolist";
import { notes } from "./apps/notes";
import { elmascoffee } from "./apps/elmascoffee";
import { weather } from "./apps/weather";
import { pin } from "./apps/pin";
import { calculator } from "./apps/calculator";
import { clipboard } from "./apps/clipboard";
import { akademyati } from "./apps/akademyati";
import { projiz } from "./apps/projiz";
import encode from "./apps/encode";
import { lens } from "./apps/lens";
import { links } from "./apps/links";
import { textlab } from "./apps/textlab";
import { enigma } from "./apps/enigma";
import { widget } from "./apps/widget";
import { json } from "./apps/json";
import { snipboard } from "./apps/snipboard";

const apps = [
    projiz,
    lens,
    akademyati,
    elmascoffee,
    widget,
    tools,
    textlab,
    links,
    json,
    todolist,
    encode,
    snipboard,
    enigma,
    clipboard,
    pin,
    notes,
    weather,
    calculator,
];

export default apps;
